"use strict";

exports.__esModule = true;
var _Checkbox = require("./Checkbox");
Object.keys(_Checkbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Checkbox[key]) return;
  exports[key] = _Checkbox[key];
});